const colors = {
  gray: { background: '#f7f7f7', color: 'black' },
  deepGray: { background: 'transparent', color: '#222' },
  black: { background: 'black', color: 'white' },
  white: { background: 'white', color: 'black' },
  transparent: { background: 'transparent', color: 'white' }
};

const colorsRGB = {
  gray: { background: '247, 247, 247', color: '255, 255, 255' },
  deepGray: { background: '34,34,34', color: 'transparent' },
  black: { background: '0, 0, 0', color: '255, 255, 255' },
  white: { background: '255, 255, 255', color: '0, 0, 0' },
  transparent: { background: '0, 0, 0', color: '255, 255, 255' }
};

const getColors = color => (colors[color] ? colors[color] : colors.white);
const getColorsRGB = color => {
  const normalizedColor = color === '#f7f7f7' ? 'gray' : color;
  return colorsRGB[normalizedColor]
    ? colorsRGB[normalizedColor]
    : colorsRGB.white;
};

module.exports = { getColors, getColorsRGB };
